import Api from '@/services/Api'

export default class {
  getUserClients () {
    return Api().get("user/client")
  }
  authorizeClient (activationCode, elevatedAccess) {
    let formData = new FormData()
    formData.append('activationCode', activationCode)
    formData.append('elevatedAccess', elevatedAccess)
    return Api().post('user/authorize-client', formData)
  }
  revokeClient (clientID) {
    let formData = new FormData()
    formData.append('clientID', clientID)
    formData.append('force', true)
    return Api().post("user/revoke-client", formData)
  }
  updateClient(clientID, clientData) {
    let formData = new FormData()
    formData.append('Name', clientData.Name)
    return Api().post('user/client/' + clientID + '/update', formData)
  }
}
